function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.4541 24.9638C28.9059 24.9638 31.7041 22.1656 31.7041 18.7139C31.7041 15.2621 28.9059 12.4639 25.4541 12.4639C22.0023 12.4639 19.2041 15.2621 19.2041 18.7139C19.2041 22.1656 22.0023 24.9638 25.4541 24.9638Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.052 45.6626L10.0325 40.3713C7.66979 38.2915 7.59644 34.6243 9.89107 32.4659C12.982 29.5635 17.3146 25.8806 21.1285 24.0312",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7217 67.1624C15.8298 51.5977 16.9562 34.8438 16.9562 34.8438",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9942 34.8438C32.9942 34.8438 34.7387 44.2999 32.2607 66.3347",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.4961 66.9113V49.7383",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M29.625 23.376C30.9504 24.0885 33.9838 25.8906 36.949 28.8401C38.6306 30.5061 39.2331 30.9619 42.3869 34.8439C42.3869 34.8439 46.4628 30.197 48.7836 32.7483C51.1359 35.3311 47.6153 38.113 42.7013 41.7959C41.4806 42.7075 39.778 42.5765 38.7145 41.4868L33.2084 35.834",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2325 76.0164H12.708V67.4089L39.2325 66.335V76.0164Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7083 70.5781H1.32422V76.0161H12.7083V70.5781Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M56.3107 70.5781H39.2319V76.0161H56.3107V70.5781Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3052 70.5791V38.9834",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3052 32.094V5.09277",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M66.3183 27.7505C66.3183 27.7505 62.101 25.896 55.3586 25.896C50.0149 25.896 46.311 27.7505 46.311 27.7505V7.73798C46.311 7.73798 49.5382 4.99805 56.3173 4.99805C63.5155 4.99805 66.3236 7.73798 66.3236 7.73798V27.7505H66.3183Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M66.7008 21.0919C73.8781 21.0919 75.5126 18.792 75.5126 18.792L71.0753 31.2867L75.5126 38.8045C75.5126 38.8045 72.1755 40.6905 66.3184 40.6905C60.4561 40.6905 57.8838 38.8045 57.8838 38.8045V26.5089",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M66.3184 28.2744C66.3184 28.2744 59.7855 30.3281 57.8838 38.8046",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3055 5.09245C47.431 5.09245 48.3434 4.18004 48.3434 3.05453C48.3434 1.92901 47.431 1.0166 46.3055 1.0166C45.18 1.0166 44.2676 1.92901 44.2676 3.05453C44.2676 4.18004 45.18 5.09245 46.3055 5.09245Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M9.91659 7.86412L13.5262 9.57199L9.91659 11.2799L8.20871 14.8895L6.50084 11.2799L2.89648 9.57199L6.50084 7.86412L8.20871 4.25977L9.91659 7.86412Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M64.7677 55.3701L70.3995 58.0367L64.7677 60.7033L62.1011 66.3351L59.4345 60.7033L53.8027 58.0367L59.4345 55.3701L62.1011 49.7383L64.7677 55.3701Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function Svg2Franqueado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Franqueado);
export default __webpack_public_path__ + "static/media/2-franqueado.cf7382c958fb9427945a68289da3f21d.svg";
export { ForwardRef as ReactComponent };